// @flow strict
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { startWebVitals, trackPageView } from './index.js';

const RouteAnalytics = () => {
  const { pathname } = useLocation();
  const isInitialPageView = React.useRef(true);

  React.useEffect(() => {
    startWebVitals();
    trackPageView(pathname, isInitialPageView.current, isInitialPageView.current);
    isInitialPageView.current = false;
  }, [pathname]);

  return null;
};

export default RouteAnalytics;
